import { isSbLinkValid } from '@/utils/helpers/isSbLinkValid';
import { IIconTile } from '@/utils/interfaces/components';
import { Fragment } from 'react';
import { Icon } from '../Icon';
import { Arrow } from '../Icons/Arrow';
import { SbLink } from '../SbLink';
import { FormattedText } from '../FormattedText';

interface IProps {
	blok: IIconTile;
}

export const SimpleIconTile: React.FC<IProps> = ({ blok }) => {
	function TileContent() {
		const imageUrl = blok.main_image?.startsWith('http')
			? blok.main_image
			: `https:${blok.main_image}`;
		return (

			<Fragment>
				<div className="z-0 absolute-fill bg-green-dark group">
					<div className="absolute bottom-3 right-3 transform transition-transform duration-300 group-hover:translate-x-1 group-hover:translate-y-[-2px]">
						<Icon className="w-[12px] h-[10px] text-white" icon={<Arrow />} />
					</div>
				</div>

				<div className="relative h-full text-left bg-white shadow-soft group-hover:rounded-br-[90px] z-10 transition-all ">
					{blok.main_image && (
						<div
							className="w-full h-[292px] bg-cover bg-center"
							style={{
								backgroundRepeat: "no-repeat",
								backgroundImage: `url(${blok.main_image.startsWith('http') ? blok.main_image : 'https:' + blok.main_image})`,
							}}
						/>
					)}
					<div className='p-6'>
						<div className="text-[22px] leading-tight">
							{(() => {
								const parts = blok.title.split(/\*\*(.*?)\*\*/);
								return (
									<>
										<span className='font-normal text-green-dark'>{parts[0].trim()}</span>{' '}
										{parts[1] && <span className="text-green font-bold hightlight-text">{parts[1]}</span>}
									</>
								);
							})()}
						</div>
						<span className="block mt-2 leading-5 font-light text-base opacity-80">
							{blok.description}
						</span>
					</div>
				</div>
			</Fragment>
		);
	}

	if (isSbLinkValid(blok.link)) {
		return (
			<SbLink link={blok.link}>
				<a className="relative block w-full h-full group">
					<TileContent />
				</a>
			</SbLink>
		);
	} else {
		return (
			<div className="relative block w-full h-full">
				<TileContent />
			</div>
		);
	}
};
